<div class="date-picker">
  <input hidden type="text" #datePicker>
  <div class="date-picker-container">
    <div #container></div>
  </div>
</div>
